var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1695_2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1695_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3679 20.2405C22.8711 20.2405 25.7214 17.3908 25.7214 13.8877C25.7214 10.3839 22.8711 7.53418 19.3679 7.53418C15.8641 7.53418 13.0144 10.3839 13.0144 13.8877C13.0151 17.3908 15.8648 20.2405 19.3679 20.2405Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3687 2.00879C9.79633 2.00879 2.0083 9.79613 2.0083 19.3685C2.0083 28.9416 9.79633 36.7296 19.3687 36.7296C28.9411 36.7296 36.7284 28.9416 36.7284 19.3685C36.7284 9.79613 28.9411 2.00879 19.3687 2.00879ZM19.3687 3.73517C27.9889 3.73517 35.002 10.749 35.002 19.3685C35.002 22.9116 33.8152 26.1816 31.8225 28.8063C30.96 24.7457 27.3486 21.6897 23.034 21.6897H15.7027C11.3889 21.6897 7.7767 24.7464 6.91489 28.8063C4.92079 26.1809 3.73468 22.9116 3.73468 19.3685C3.73468 10.7483 10.7485 3.73517 19.3687 3.73517Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1695_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1695_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.691,
    height: 54.691,
    fill: "white",
    transform: "matrix(0.69 0 0 0.69 0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.1b3d4ce31bcf403554b0b96df54b52b0.svg";
export { ForwardRef as ReactComponent };